import { useProblem } from "../contexts/problem-context";
import GreenCheckIcon from "../icons/green-check";

export default function ProblemSidebar() {
  const [{ status }] = useProblem();
  return (
    <div className="col-span-12 lg:col-span-4 sm:mb-0 mb-6">
      <ol className="relative text-gray-500 border-r border-gray-200">
        <li className="mb-10 mr-6">
          <span className="absolute flex items-center justify-center w-8 h-8 bg-gray-100 rounded-full -right-4 ring-4 ring-white">
            {status !== "type" ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-5 h-5"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 00.75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 00-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0112 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 01-.673-.38m0 0A2.18 2.18 0 013 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 013.413-.387m7.5 0V5.25A2.25 2.25 0 0013.5 3h-3a2.25 2.25 0 00-2.25 2.25v.894m7.5 0a48.667 48.667 0 00-7.5 0M12 12.75h.008v.008H12v-.008z"
                />
              </svg>
            ) : (
              <GreenCheckIcon />
            )}
          </span>
          <h3 className="font-medium leading-tight">انتخاب نوع تصمیم</h3>
          <p className="text-sm">انتخاب کنید چه نوع تصمیمی میگیرید</p>
        </li>
        <li className="mb-10 mr-6">
          <span className="absolute flex items-center justify-center w-8 h-8 bg-gray-100 rounded-full -right-4 ring-4 ring-white">
            {status !== "create" ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-5 h-5"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 00.75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 00-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0112 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 01-.673-.38m0 0A2.18 2.18 0 013 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 013.413-.387m7.5 0V5.25A2.25 2.25 0 0013.5 3h-3a2.25 2.25 0 00-2.25 2.25v.894m7.5 0a48.667 48.667 0 00-7.5 0M12 12.75h.008v.008H12v-.008z"
                />
              </svg>
            ) : (
              <GreenCheckIcon />
            )}
          </span>
          <h3 className="font-medium leading-tight">ایجاد تصمیم</h3>
          <p className="text-sm">نام و معیار‌ها را اینجا وارد کنید</p>
        </li>
        <li className="mb-10 mr-6">
          <span className="absolute flex items-center justify-center w-8 h-8 bg-gray-100 rounded-full -right-4 ring-4 ring-white">
            {status !== "alternatives" ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-5 h-5"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M3.75 6A2.25 2.25 0 016 3.75h2.25A2.25 2.25 0 0110.5 6v2.25a2.25 2.25 0 01-2.25 2.25H6a2.25 2.25 0 01-2.25-2.25V6zM3.75 15.75A2.25 2.25 0 016 13.5h2.25a2.25 2.25 0 012.25 2.25V18a2.25 2.25 0 01-2.25 2.25H6A2.25 2.25 0 013.75 18v-2.25zM13.5 6a2.25 2.25 0 012.25-2.25H18A2.25 2.25 0 0120.25 6v2.25A2.25 2.25 0 0118 10.5h-2.25a2.25 2.25 0 01-2.25-2.25V6zM13.5 15.75a2.25 2.25 0 012.25-2.25H18a2.25 2.25 0 012.25 2.25V18A2.25 2.25 0 0118 20.25h-2.25A2.25 2.25 0 0113.5 18v-2.25z"
                />
              </svg>
            ) : (
              <GreenCheckIcon />
            )}
          </span>
          <h3 className="font-medium leading-tight">ایجاد گزینه‌ها</h3>
          <p className="text-sm">گزینه‌های تصمیم خود را ایجاد کنید</p>
        </li>
        <li className="mb-10 mr-6">
          <span className="absolute flex items-center justify-center w-8 h-8 bg-gray-100 rounded-full -right-4 ring-4 ring-white">
            {status !== "questions" ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-5 h-5"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z"
                />
              </svg>
            ) : (
              <GreenCheckIcon />
            )}
          </span>
          <h3 className="font-medium leading-tight">سوالات</h3>
          <p className="text-sm">پاسخ به سوالات ایجاد شده</p>
        </li>
        <li className="mr-6">
          <span className="absolute flex items-center justify-center w-8 h-8 bg-gray-100 rounded-full -right-4 ring-4 ring-white">
            {status !== "finished" ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-5 h-5"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M3.75 3v11.25A2.25 2.25 0 006 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0118 16.5h-2.25m-7.5 0h7.5m-7.5 0l-1 3m8.5-3l1 3m0 0l.5 1.5m-.5-1.5h-9.5m0 0l-.5 1.5m.75-9l3-3 2.148 2.148A12.061 12.061 0 0116.5 7.605"
                />
              </svg>
            ) : (
              <GreenCheckIcon />
            )}
          </span>
          <h3 className="font-medium leading-tight">مشاهده نتایج</h3>
          <p className="text-sm">نتایج را اینجا مشاهده کنید</p>
        </li>
      </ol>
    </div>
  );
}
